import React from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { baseColors, baseFontFamily, dimensions } from "@Constants/baseStyles"
import Modal from "react-native-modal"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { RFValue } from "react-native-responsive-fontsize"
import SvgClose from "@Components/CustomIcon/SvgClose"

const ConclusionItemDetails = (props) => {
    const { isModalVisible, toggleModal, selectedConclusion } = props
    const { label, details, subtitle } = selectedConclusion

    return (
        <Modal
            isVisible={isModalVisible}
            animationIn="fadeInUp"
            animationOut="fadeOutDown"
            swipeDirection={["left", "right", "down"]}
            //onDismiss={toggleModal}
            onSwipeComplete={toggleModal}
            onBackButtonPress={toggleModal}
            style={{
                justifyContent: "flex-end",
                margin: 0
            }}
        >
            <View
                style={{
                    height: dimensions.fullHeight / 1.5,
                    backgroundColor: "white",
                    backgroundColor: "#fff",
                    paddingHorizontal: 20,
                    paddingVertical: 25,
                    borderTopLeftRadius: 10,
                    borderTopRightRadius: 10
                }}
            >
                <TouchableOpacity
                    onPress={toggleModal}
                    style={{ flexDirection: "row", justifyContent: "flex-end", paddingRight: 10 }}
                >
                    <SvgClose height={15} width={15} />
                </TouchableOpacity>

                <BreeSerifText
                    fontSize={RFValue(20)}
                    style={{
                        textAlign: "center",
                        marginVertical: 10,
                        color: baseColors.orange.primary
                    }}
                >
                    {label ?? ""}
                </BreeSerifText>

                {subtitle !== "" && (
                    <BreeSerifText
                        fontSize={RFValue(14)}
                        style={{
                            textAlign: "center",
                            marginVertical: 10,
                            color: baseColors.green.primary
                        }}
                    >
                        {subtitle}
                    </BreeSerifText>
                )}

                <ScrollView contentContainerStyle={{ paddingBottom: 50 }}>
                    <TouchableOpacity>
                        <OpenSansText
                            style={{ color: baseColors.black }}
                            defaultFontFamily={baseFontFamily.OpenSansRegular}
                            fontSize={14}
                        >
                            {details ?? ""}
                        </OpenSansText>
                    </TouchableOpacity>
                </ScrollView>
            </View>
        </Modal>
    )
}

export default ConclusionItemDetails
